import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PackageService', PackageService);

  PackageService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'PackageModalService',
    'SessionService',
  ];

  function PackageService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    PackageModalService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'packages';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPackages: getPackages,
      getPackage: getPackage,
      savePackage: savePackage,
      deletePackage: deletePackage,
      changePackageStatus: changePackageStatus,
      openPackageListModal: openPackageListModal,

      setDefaultAssociatedProvider: setDefaultAssociatedProvider,
      getPackageAvailabilitySchedule: getPackageAvailabilitySchedule,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getPackages(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getPackage(id, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePackage(item) {
      var method = 'post';

      var url = apiUrl;
      if (item.id) {
        // edit
        url += '/' + item.id;
        method = 'put';
      }

      function success(response) {
        var msg = !item.id ? 'PACKAGE_ADDED' : 'PACKAGE_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { package: item }, success, failure);
    }

    function deletePackage(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_PACKAGE',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'PACKAGE_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changePackageStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openPackageListModal(websiteId) {
      PackageModalService.openPackageListModal(websiteId);
    }

    function setDefaultAssociatedProvider(providerId, packagelId, successCallback) {
      var url = apiUrl + '/' + packagelId + '/set_default_associated_provider';

      return RestResource.request(
        'put',
        url,
        { provider_id: providerId },
        function () {
          var msg = $translate('DEFAULT_PROVIDER_CHANGED');
          utils._successMsg(msg);

          return successCallback(providerId);
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function getPackageAvailabilitySchedule(id, filterCriteria) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/get_package_availability_schedule',
        filterCriteria,
        function (response) {
          return response;
        },
        function () {
          return false;
        }
      );
    }
  }
})();
